//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FileUploader from '~/components/form/FileUploader'
import InputGroup from '~/components/form/InputGroup'

export default {
  name: 'ResumeForm',
  components: {
    InputGroup,
    FileUploader
  },
  props: {
    resume: {
      type: Object,
      required: true
    },
    validation: {
      type: Object,
      default () {
        return {}
      }
    },
    stacked: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      item: {}
    }
  },
  computed: {
    fileUrl () {
      return `${process.env.bucketURL}/${this.item?.File?.fileName}`
    },
    columnClasses () {
      return this.stacked ? 'col-12 mb-3' : 'col-12 col-lg-4'
    }
  },
  mounted () {
    // clone object to be able to edit it
    this.item = { ...this.resume }
  },
  methods: {
    handleFileOpen () {
      window.open(this.fileUrl)
    },
    handleFileSelect (file) {
      this.item.fileId = file.id
      this.item.File = file
      this.handleChange()
    },
    handleChange () {
      this.$emit('change', this.item)
    }
  }
}
